<template>
  <div id="app">
    <Header :pagename="pagename" />
    <secTop />
    <div class="circle-wrap hidePc" id="Spfixed">
      <Graphic />
    </div>
    <vidModal :vidSrc="vidSrc" @clicked="modalClose()" v-if="modal"/>
    <contentModal :vidSrc="vidSrc" @clicked="contentModalClose()" v-if="contentModal"/>
    <div class="section kv"></div>
    <div class="section message" id="coverSec">
      <div class="container">
        <h2title text="message" num="01" />
        <h3>
          <small>「栄養の日・栄養週間 2020」</small><br>
          開会宣言
        </h3>
        <p>
          日本栄養士会は、新しい生活様式に、<br>
          管理栄養士・栄養士が考案する「予防めし」を提案します。
        </p>
        <div class="video-wrap">
          <a class="video-btn" @click="modalOn()">
            <IconPlay />
          </a>
          <img src="@/assets/video-thumb.jpg" alt="">
        </div>
      </div>
    </div>
    <div class="section white">
      <div class="bg-texture"></div>
        <div class="container">

          <h2title text="contents" num="02" class="c2"/>
          <div class="inner-contents yobo">
            <sectionImg section="bg-yobo" />
            <h3>
              <small>免疫機能を低下させないで<br>感染症の予防に役立つ<br class="hidePc">食事を提案</small><br>
              「予防めし」
            </h3>
            <p>
              新しい生活様式を実践するみなさんへ、<br class="hidePc">日本栄養士会からの新しい提案です。<br>
              食と栄養の専門職である<br class="hidePc">管理栄養士と栄養士が考えた「予防めし」。<br>
              今回は、継続して適正な食生活を送るための<br class="hidePc">一助となるような食事例を<br>
              SNSやYouTubeで発信していきます。<br class="hidePc">ぜひ、参考にしてみてください！
            </p>
            <btnRounded to="./yobomeshi" class="yellow middle font-large">「予防めし」レシピ集を見る</btnRounded>
          </div>
          <div class="inner-contents kanri">
            <sectionImg section="bg-kanri" />
            <h3>
              <small>管理栄養士・栄養士が実演する<br>YouTube動画集</small><br>
              家庭でできる<br class="hidePc">衛生管理術
            </h3>
            <p>
              日々の食生活に役立つ<br class="hidePc">衛生管理のポイントについて、<br>
              食と栄養の専門職からご提案します。<br>
              家庭や職場でも実践できる方法を<br class="hidePc">動画でまとめました。
            </p>
            <btnRounded href to="https://www.youtube.com/playlist?list=PLQSUnxiaJEopvwMPnzmWaSkf9k9v509pF" target="_blank" class="yellow middle font-large">YouTube動画集を見る</btnRounded>
          </div>

          <div class="inner-contents kouza">
            <sectionImg section="bg-kouza" />
            <h3>
              <small>免疫を高める秘訣が<br class="hidePc">簡単にわかる</small><br>
              動画で見る<br class="hideMidl">「市民公開講座」<br>
              <small class="subtitle">- 免疫を味方にして新型<br class="hideMidl">コロナウイルスに負けない -</small>
              <small class="subtitle">第41回「健康づくり提唱のつどい」</small>
            </h3>
            <span class="caption">supported by 株式会社ヤクルト本社</span>
            <p>
              免疫の仕組み、免疫を高める秘訣、<br class="hidePc">免疫機能を支える食事の秘訣と、<br>
              3つのストーリーに分けてご紹介。<br>
              今こそ必要な情報を、<br class="hidePc">わかりやすくお伝えします。
            </p>
            <btnRounded to="./open_lecture/" class="yellow middle font-large">免疫について学ぼう！</btnRounded>
          </div>

          <div class="inner-contents sindan">
            <sectionImg section="bg-sindan" />
            <h3>
              <small>今、知っておきたい<br class="hidePc">栄養の知識がいっぱい</small><br>
              栄養力診断<br><small class="subtitle">-免疫の基本が<br class="hidePc">まるわかり編-</small>
            </h3>
            <p>
              「栄養力診断」は、<br class="hidePc">気軽に楽しく「栄養」を学べる<br class="hidePc">診断タイプのコンテンツです。<br>
              今回は<br class="hidePc">「免疫を味方にして感染症に負けない！」<br class="hidePc">をテーマに、<br>
              免疫と栄養に関する知識が身につく10問。<br>
              答えのヒントは、「市民公開講座」をチェックしてみましょう！
            </p>
            <btnRounded to="https://www.nutas.jp/84shindan/" href target="_blank" class="yellow middle font-large">栄養力診断を受ける</btnRounded>
          </div>

      </div>

      <div class="container">
        <h2title text="partner" num="03" class="c2 box"/>
        <span class="border-box">特別協賛</span>
        <div class="inner-contents partner">
          <div class="grid-wrapper">
            <a href="https://www.itoen.co.jp/"
              target="_blank"><img src="@/assets/partner/01.jpg"></a>
            <a href="https://www.zespri-jp.com/" 
            target="_blank"><img src="@/assets/partner/02.jpg"></a>
            <a href="https://www.meiji.co.jp/" 
            target="_blank"><img src="@/assets/partner/03.jpg"></a>
            <a href="https://www.yakult.co.jp/" 
            target="_blank"><img src="@/assets/partner/04.jpg"></a>
            <a href="https://www.ajinomoto.co.jp/" 
            target="_blank" class="three-row"><img src="@/assets/partner/05.jpg"></a>
            <a href="https://www.instantramen.or.jp/" 
            target="_blank" class="three-row"><img src="@/assets/partner/06.jpg"></a>
            <a href="http://www.daiichi-shuppan.co.jp/" 
            target="_blank" class="three-row"><img src="@/assets/partner/07.jpg"></a>
          </div>
          <span class="border-box">一般協賛</span>
          <div class="normal">
            <a href="https://www.satonoyuki.co.jp/" target="_blank"><p>さとの雪食品株式会社</p></a>
          </div>
          <p class="organizer">［ 主催 ］<br class="hidePc"> 公益社団法人 日本栄養士会、<br class="hidePc">47都道府県栄養士会</p>
        </div>
        
      </div>

      <div class="container">
        <h2title text="contact" num="04" class="c2"/>
        <div class="inner-contents contact">
          <btnRounded multi target="_blank" to="https://www.dietitian.or.jp/84/" 
            class="yellow large font-middle full">管理栄養士・栄養士のみなさんへ<br>「栄養の日・栄養週間 2020」に関する<br>お知らせはこちら</btnRounded>
          <btnRounded target="_blank" to="https://www.dietitian.or.jp/contact/media.html"
            class="yellow large font-middle">メディアのみなさまはこちら</btnRounded>
        </div>
        <div class="inner-contents nutas">
          <div class="nutas-box">
            <img src="@/assets/logo-nutas-mark.png" alt="ニュータス" class="logo">
            <div class="text-box">
              <p class="bold">
                あなたの毎日に栄養(Nutrition)をプラス<br>
                NU+（ニュータス）は、<br class="hidePc">食でカラダを健やかにするWEBマガジンです。
              </p>
              <p class="text">
                次の日の朝食に取り入れられるアイデアから、<br class="hidePc">カラダのお悩みを解決する<br>
                HOW TOまで、<br class="hidePc">栄養に関するさまざまな情報を<br class="hidePc">発信していきます。<br> 
                すべての情報は専門的な知見から<br class="hidePc">管理栄養士・栄養士が監修し、<br>
                信頼できるものだけをお届けしています。
              </p>
              <btnRounded target="_blank" to="https://www.nutas.jp/" href class="yellow middle font-middle">NU+(ニュータス)へ</btnRounded>
            </div>
          </div>
        </div>
       <Share />
      </div>
      <Footer />
    </div>
    <div class="bg-texture over"></div>
  </div>
</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'
import secTop from '@/components/sec-top.vue'
import vidModal from '@/components/vidmodal.vue'
import contentModal from '@/components/content-modal.vue'
import h2title from '@/components/section-title.vue'
import btnRounded from '@/components/parts/btn-rounded.vue'
import Share from '@/components/parts/share.vue'
import sectionImg from '@/components/parts/sectionImg.vue'
//svg inline

import IconPlay from '@/assets/icon-play.svg?inline'
import Graphic from '@/assets/graphic1.svg?inline'

import TweenLite from 'gsap';
import { vueWindowSize } from 'vue-window-size';
vueWindowSize.init();

export default {
  name: 'Top',
  components: {
    secTop,
    Header,
    Footer,
    vidModal,
    contentModal,
    h2title,
    btnRounded,
    Share,
    sectionImg,
    //svg
    IconPlay,
    Graphic
  },
  data(){
    return{
      pagename: 'top',
      paragraph:[
        {
          p : '変化は、突然やってくる。<br>'+
          'これは、新しい生活を迎えた<br class="hidePc">みんなにおくる、<br>'+
          '栄養からのエールだ。'
        },
        {
          p:'やせたいとか、<br class="hidePc">きれいになりたいとか<br>'+
          'そのもっともっと手前の部分、<br>'+
          '元気に、健やかでありたい。<br>'+
          'その大切なことに気づいた<br class="hidePc">今だから。'
        },
        {
          p:'さあ、もう一度考えてみよう<br>'+
          '食べること、<br class="hidePc">栄養をとるということ。<br>'+
          'それはつまり、<br class="hidePc">生きていくということ。'
        },
        {
          p:'身近なことからはじめよう<br>'+
          '小さなことでも、少しづつ<br>'+
          'できるだけ、<br class="hidePc">バランスよく丁寧に。'
        },
        {
          p:'あなたの大切なひとに、<br>'+
          'これからも<br class="hidePc">元気でいてほしいから。'
        },
        {
          p:'今からでも遅くないよ。<br>'+
          '今日が、<br class="hidePc">そのきっかけの日なんだ。'
        }
      ],
      modal: false,
      contentModal: true,
      vidSrc: "zU877RoPOCs"
    }
  },
  created(){
      window.addEventListener('scroll', this.hideTop)
  },
  methods:{
    playVideo() {
      this.$refs.youtube.player.playVideo()
    },

    modalOn() {
      if(this.modal == false){
        this.modal = true
      }
      else{
        this.modal = false
      }
    },
    modalClose(){
      this.modal = false
    },
    contentModalClose(){
      this.contentModal = false
    },
    hideTop(){
      const target = document.getElementById("coverSec").offsetTop - this.windowHeight
      let el
      if( this.windowWidth < 769){
        el = document.getElementById('Spfixed')
      }
      else{
        el = document.getElementById('topBg')
      }
      let Scroll = window.scrollY
      //console.log(target + 'and' + Scroll);
      // if( (Scroll-target) > 0 && (Scroll-target) < this.windowHeight){
      if( (Scroll-target) > 0 ){
        let i = Scroll - target
        el.setAttribute('style', 'transform: translateY(-' + i + 'px);')
      }
      else{
         el.setAttribute('style', 'transform: translateY(0);')
      }
    }
  },
  mounted(){
    
  },
  computed: {
    
  }
}
</script>

<style lang="scss" scoped>

.circle-wrap{
  position: fixed;
  display: block;
  top: -50%;
  left: -25vw;
  width: 150vw;
  height: 150vh;
  min-height: 780px;
  min-width: 780px;
  z-index: -1;
    svg{
      width: 100%;
      height: 100%;
      animation-name: rotateOnly;
      animation-iteration-count: infinite;
      animation-duration: 24s;
      animation-timing-function: linear;
    }
    @media #{$maxXS}{
      left: -50%;
      top: -48%;
    }
}

.section{
  justify-content: center;
  align-items: center;
  p{
      font-size: 1.688em;
      line-height: 2.481em;
      letter-spacing: 0.26rem;
  }
  &.kv {
      height: 100vh;
      @media #{$maxM}{
          display: none;
      }
  }
  &.message {
    background: transparent;
    h3 {
      text-align: center;
      small {
        display: inline-block;
        line-height: 1.8;
      }
    }
    p{
      font-family: $yugothic;
      text-align: center;
      font-size: 1.125em;
      font-weight: 500;
      line-height: 2.4em;
      letter-spacing: normal;
      margin: 60px auto;
      @media #{$maxM}{
        margin: 40px auto;
        font-size: 1.143em;
        line-height: 1.8125em;
      }
    }
  }
  &.paragraph{
    
    margin: 0 auto;
    align-items: flex-start;
    @media #{$maxM}{
      max-width: 640px;
    }

    .container{
      width: auto;
      padding-left: 14vw;
      @media screen and (max-width: 1200px){
        padding-left: 10vw;
      }
      @media #{$maxM}{
        padding-left: 20px;
      }
      p{
        line-height: 2.481em;
        letter-spacing: 0.26rem;
        @media #{$maxM}{
          font-size:  1.5em;
          letter-spacing: 0.1em;
          margin-bottom: 120px;
        }
      }
      .logo-wrap{
        max-width: 300px;
        width: 100%;
        margin-left: 7vw;
        @media screen and (max-width: 980px){
          margin-left: 30px;
        }
        @media #{$maxM}{
          margin-top: 98px;
          margin-left: 0;
          margin-bottom: 180px;
        }
          img.logo{
            padding: 0 35px;
            width: calc(100% - 70px);
            margin-bottom: 52px;
          }
      }
    }
    &.center{
      @media #{$maxM}{
        align-items: center;
      }
      @media #{$IE}{
        position: relative;
        z-index: 2;
      }
    }
  }
  
  &.full-height{
    height: 100vh;
    min-height: 740px;
    @media #{$maxM}{
      height: auto;
      min-height: unset;
    }
  }
  &.white{
    background-color: $white;
    padding-top: 210px;
    position: relative;
    width: 100vw;
    @media #{$maxM}{
      padding-top: 103px;
    }
      .container{
        z-index: 1;
      }
  }
  .bg-texture{
    z-index: 0;
    position: absolute;
  }
  .section-title{
    margin-bottom: 140px;
    @media #{$maxM}{
      margin-bottom: 40px;
    }
    &.box{
      margin-bottom: 60px;
      @media #{$maxM}{
        margin-bottom: 50px;
      }
    }
  }

  .border-box{
    border: 1px solid $black;
    padding: 9px 14px;
    font-family: $yugothic;
    font-size: 1em;
    font-weight: 600;
    letter-spacing: normal;
    margin-bottom: 60px;
    @media #{$maxM}{
      font-size: 1.143em;
      margin-bottom: 30px;
    }
    @media #{$IE}{
      padding-top: 15px;
      padding-bottom: 10px;
    }
  }

  .container{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
      .video-wrap{
        width: 800px;
        height: 100%;
        margin-bottom: 150px;
        @media #{$IE}{
            box-sizing: border-box;
        }
        @media screen and (max-width: 980px){
          width: 640px;
        }
        @media #{$maxM}{
          width: 100%;
          margin-bottom: 180px;
        }
        .video-btn{
          width: 120px;
          height: 120px;
          right: 20px;
          bottom: 20px;
          @media #{$maxM}{
            width: 68px;
            height: 68px;
            right: 20px;
            bottom: 20px;
          }
          @media #{$maxXS}{
            width: 50px;
            height: 50px;
            bottom: 10px;
          }
            svg{
              width: 12px;
              height: 12px;
              @media #{$maxM}{
                transform: scale(0.6);
              }
            }
        }
      }

      .inner-contents{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        padding-left: 20px;
        padding-right: 20px;
        width: calc(100% - 40px);
        @media #{$maxM}{
          width: 100%;
        }
        &:first-child{
          padding-top: 0;
        }
        h3{
          text-align: center;
          margin-bottom: 60px;
          position: relative;
          @media #{$maxM}{
            margin-bottom: 40px;
            line-height: 1.325em;
          }
          small {
            display: inline-block;
            line-height: 1.8;
          }
        }
        p{
          font-family: $yugothic;
          text-align: center;
          font-size: 1.125em;
          font-weight: 500;
          line-height: 2.4em;
          letter-spacing: normal;
          @media #{$maxM}{
            font-size: 1.143em;
            line-height: 1.8125em;
          }
        }
      }

      .yobo{
        margin-bottom: 300px;
        @media #{$maxM}{
          margin-bottom: 170px;
        }
        .btn{
          width: calc(480px - 48px - 94px);
          padding-left: 48px;
          padding-right: 94px;
          margin-top: 60px;
          // margin-bottom: 260px;
          margin-bottom: 60px;
          @media #{$maxM}{
            margin-top: 40px;
            margin-bottom: 40px;
          }
          @media #{$IE}{
            width: 480px;
            padding-top: 30px;
            padding-bottom: 20px;
          }
        }
      }
      .kanri{
        .btn{
          width: calc(450px - 57px - 78px);
          padding-left: 57px;
          padding-right: 78px;
          margin-top: 60px;
          margin-bottom: 260px;
          @media #{$maxM}{
            margin-top: 40px;
            margin-bottom: 170px;
          }
          @media #{$IE}{
            width: 450px;
          }
        }
      }
      .sindan{
        .btn{
          width: calc(450px - 63px - 99px);
          padding-left: 63px;
          padding-right: 99px;
          margin-top: 60px;
          margin-bottom: 260px;
          @media #{$maxM}{
            margin-top: 40px;
            margin-bottom: 170px;
          }
          @media #{$IE}{
            width: 450px;
          }
        }
        .subtitle {
          font-size: 1em;
          @media #{$minM}{
            white-space: pre;
          }
          @media #{$maxM}{
            font-size: 0.7em;
          }
        }
      }
      .kouza{
        h3{
          margin-bottom: 20px;
          @media #{$maxM}{
            white-space: nowrap;
            margin-top: 30px;
          }
        }
        .caption{
            font-size: 18px;
            margin-bottom: 60px;
            @media #{$maxM}{
              font-size: 14px;
              letter-spacing: 0.1em;
            }
            @media #{$maxSS}{
              font-size: 10px;
            }
        }
        .btn{
          width: calc(450px - 93px - 123px);
          padding-left: 93px;
          padding-right: 123px;
          margin-top: 60px;
          margin-bottom: 260px;
          @media #{$maxM}{
            margin-top: 40px;
            margin-bottom: 170px;
          }
          @media #{$IE}{
            width: 450px;
          }
        }
      }
      .partner{
        .grid-wrapper{
          max-width: calc(780px  - 40px);
          display: flex;
          flex-flow: row wrap;
          justify-content: space-between;
          padding: 0 20px;
          margin-bottom: calc(100px - 22px);
          @media #{$maxM}{
            width: 100%;
            padding: 0;
            margin-bottom: 45px;
          }
            a{
              max-width: calc(50% - 22px);
              margin: 22px 0;
              height: 100%;
              @media #{$maxM}{
                margin: 5px 0;
                max-width: calc(50% - 5px);
              }
              &:nth-child(1),
              &:nth-child(2){
                margin-top: 0;
              }
              &.three-row{
                max-width: calc(33.3333% - 22px);
                @media #{$maxM}{
                  max-width: calc(33.3333% - 5px);
                }
              }
            }
        }
        .normal{
          max-width: calc(780px  - 40px);
          width: calc(100% - 40px);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 0px 20px 60px 20px;
          border-bottom: 1px solid $black;
        }
        a{
          &:hover{
            opacity: 0.7;
            text-decoration: underline;
          }
        }
        p{
          font-size: 1rem;
          line-height: 1.8125em;
        }
        .organizer{
          width: calc(100% - 40px);
          padding: 60px 20px 260px;
          @media #{$maxM}{
            padding-bottom: 190px;
          }
        }
      }
      .contact{
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        width: 100%;
        max-width: 980px;
        @media #{$maxL}{
          flex-direction: column;
        }
        .btn{
          width: 48%;
          min-width: 320px;
          padding-left: 7.55%;
          padding-right: 8.97%;
          margin: 0 auto;
          margin-bottom: 20px;
          box-sizing: border-box;
          @media #{$maxL}{
            min-width: 460px;
          }
          @media #{$maxM}{
            min-width: 0;
            margin-top: 10px;
            margin-bottom: 10px;
          }
          @media #{$IE}{
            padding-top: 30px;
            padding-bottom: 20px;
          }
          &.multi {
            width: 48%;
            padding-left: 3.55%;
            padding-right: 4.97%;
          }
        }
      }
      .nutas{
        margin-top: 180px;
        margin-bottom: 200px;
        @media #{$maxM}{
          margin-top: 180px;
          margin-bottom: 190px;
        }
        .nutas-box{
          display: flex;
          flex-flow: row nowrap;
          justify-content: center;
          align-items: flex-start;
          @media #{$maxM}{
            flex-flow: column;
            align-items: center;
          }
            .logo{
              height: 192px;
              width: 192px;
              margin-right: 7.072vw;
              margin-top: 1em;
              @media #{$maxM}{
                width: 140px;
                height: 140px;
                margin-right: 0;
                margin-bottom: 40px;
              }
            }
            p{
              text-align: left;
              font-size: 1rem;
              line-height: 2em;
              @media #{$maxM}{
                white-space: nowrap;
              }
              @media #{$maxSS}{
                font-size: 1.143em;
              }
              &.bold{
                font-weight: 600;
                margin-bottom: 30px;
                @media #{$maxM}{
                  margin-bottom: 0;
                }
              }
              @media #{$maxM}{
                text-align: center;
              }
            }
            .btn{
              max-width: calc(385px - 68px - 98px);
              padding-left: 68px;
              padding-right: 98px;
              margin-top: 47px;
              @media #{$maxM}{
                margin-top: 40px;
              }
              @media #{$IE}{
                max-width: 385px;
              }
            }
        }
      }
      //teaser
  }
}
.subtitle {
  display: block !important;
  letter-spacing: 0.1em;
}
</style>
